module.exports = __webpack_public_path__ + "dist/assets/ef0b9aebe1e0193c31fab76c35995fb5.woff";